import qs from 'qs';
import { addError } from './error';
import api from '../../helpers/apiClient';

export const FETCH_LOGS_REQUEST = 'FETCH_LOGS_REQUEST';
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS';
export const FETCH_LOGS_FAILURE = 'FETCH_LOGS_FAILURE';

function fetchLogsRequest(email, limit, vendor, type, title, role, log_period_start, log_period_end){
  return {
    type: FETCH_LOGS_REQUEST,
    payload: {
      email,
      limit,
      vendor,
      type,
      title,
      role,
      log_period_start,
      log_period_end,
    }
  };
}

function fetchLogsSuccess(json){
  return {
    type: FETCH_LOGS_SUCCESS,
    payload: {
      items: json,
      receivedAt: Date.now()
    }
  }
}

function fetchLogsFailure(){
  return {
    type: FETCH_LOGS_FAILURE
  };
}

function shouldFetchLogs(state){
  const results = state.logs;
  if(results && results.loading) {
    return false;
  } else {
    return true;
  }
}

function fetchLogsFromApi(email, limit, vendor, type, title, role, log_period_start, log_period_end){
  const queryString = qs.stringify({
    email,
    limit,
    vendor,
    type,
    title,
    role,
    log_period_start,
    log_period_end
  }, { skipNulls: true });
  return dispatch => {
    dispatch(fetchLogsRequest(email, limit, vendor, type, title, role, log_period_start, log_period_end));
    return api(`/logs?${queryString}`)
      .then(json => {
        dispatch(fetchLogsSuccess(json));
      })
      .catch(err => {
        dispatch(fetchLogsFailure());
        dispatch(addError(err));
      })
  }
}

export function fetchLogs(email, limit, vendor, type, title, role, log_period_start, log_period_end) {
  return (dispatch, getState) => {
    if (shouldFetchLogs(getState())) {
      return dispatch(fetchLogsFromApi(email, limit, vendor, type, title, role, log_period_start, log_period_end));
    }
  };
}
